import type { FunctionComponent } from "react";
import {
  DesktopLayoutDefault,
  DesktopLayoutDefaultContent,
  DesktopLayoutDefaultContentHeader,
} from "@kanda-libs/ks-design-library";
import CreditInfo from "components/shared/CreditInfo";
import PaymentInfo from "components/payment/PaymentInfo";
import PaymentInfoBanner from "components/payment/PaymentInfoBanner";

const PaymentLayout: FunctionComponent = function ({}) {
  return (
    <DesktopLayoutDefault>
      <DesktopLayoutDefaultContentHeader>
        <PaymentInfoBanner />
      </DesktopLayoutDefaultContentHeader>
      <DesktopLayoutDefaultContent>
        <div className="flex flex-col">
          <PaymentInfo />
          <CreditInfo />
        </div>
      </DesktopLayoutDefaultContent>
    </DesktopLayoutDefault>
  );
};

export default PaymentLayout;
